export const TERMS_OF_SERVICE_URL = 'https://www.bottle.com/company-pages/terms-of-service'
export const PRIVACY_POLICY_URL = 'https://www.bottle.com/company-pages/privacy-policy'

export const LEGAL_LINKS = Object.freeze([
  { label: 'Terms of Service', href: TERMS_OF_SERVICE_URL },
  { label: 'Privacy Policy', href: PRIVACY_POLICY_URL }
])

export const TERMS_ACCEPTED_PARAMS = Object.freeze({ terms_accepted: true })
